// @ts-nocheck

import { createSelector } from "reselect";
import moment from "moment";
import { RootState } from "src/store/rootReducer";
import {
  ListFieldsKeys,
  listFields,
  ListFieldsRecordType,
  ListFieldsType,
} from "src/api/config";
import { FIELDS_TYPES } from "src/api/config/type.config";

const getItems = (state: RootState, listName: ListFieldsKeys): number[] => {
  return state.spitems.elements.items[listName] || [];
};

const getObj = <K extends ListFieldsKeys>(
  state: RootState,
  listName: K
): Record<number, ListFieldsRecordType[K]> => {
  return state.spitems.elements.obj[listName] || {};
};

const getFields = <K extends ListFieldsKeys>(
  state: RootState,
  listName: K
): (typeof listFields)[K] => {
  return listFields[listName];
};

export const selectItems = createSelector(
  [getItems, getObj, getFields],
  (items, objs, fields) => {
    if (!items || items.length === 0) return [];

    return items.map((key) => {
      const item = objs[key];
      let obj: any = {};
      Object.keys(item).forEach((key) => {
        switch (fields[key]) {
          case FIELDS_TYPES.STRING:
          case FIELDS_TYPES.NUMBER:
          case FIELDS_TYPES.ID:
          case FIELDS_TYPES.CHOICE:
          case FIELDS_TYPES.JSON:
            obj = { ...obj, [key]: item[key] };
            break;
          case FIELDS_TYPES.DATE:
            if (item[key]) obj = { ...obj, [key]: moment(item[key]) };
            else obj = { ...obj, [key]: null };
            break;
          case FIELDS_TYPES.LOOKUP:
            obj = {
              ...obj,
              [key]: item[key] && {
                Title: item[key].get_lookupValue(),
                ID: item[key].get_lookupId(),
                Metadata: item[key].get_metadata
                  ? item[key].get_metadata()
                  : null,
              },
            };
            break;
          case FIELDS_TYPES.MULTI_LOOKUP:
            obj = {
              ...obj,
              [key]:
                (item[key as keyof typeof fields] as any) &&
                item[key as keyof typeof fields].length > 0 &&
                item[key as keyof typeof fields].map((elem: any) => {
                  return {
                    Title: elem.get_lookupValue(),
                    ID: elem.get_lookupId(),
                    Metadata: elem.get_metadata ? elem.get_metadata() : null,
                  };
                }),
            };
            break;
          case FIELDS_TYPES.MEDIA:
            obj = {
              ...obj,
              [key]: item[key] && item[key].get_url(),
            };
            break;
          case FIELDS_TYPES.LINK:
            obj = {
              ...obj,
              [key]: item[key] && item[key].get_url(),
            };
            break;
          case FIELDS_TYPES.USER:
            obj = {
              ...obj,
              [key]: item[key] && {
                Name:
                  (item[key].get_lookupValue && item[key].get_lookupValue()) ||
                  item[key]["Name"] ||
                  null,
                ID:
                  (item[key].get_lookupId && item[key].get_lookupId()) ||
                  item[key]["id"] ||
                  null,
                Email:
                  (item[key].get_email &&
                    item[key].get_email().toLowerCase().trim()) ||
                  (item[key]["email"] &&
                    item[key]["email"].toLowerCase().trim()) ||
                  null,
                Metadata: item[key].get_metadata
                  ? item[key].get_metadata()
                  : null,
              },
            };
            break;
          case FIELDS_TYPES.MULTI_USER:
            obj = {
              ...obj,
              [key]:
                (item[key as keyof typeof fields] as any) &&
                item[key as keyof typeof fields].length > 0 &&
                item[key as keyof typeof fields].map((elem: any) => {
                  return {
                    Name: elem.get_lookupValue(),
                    ID: elem.get_lookupId(),
                    Email: elem.get_email() && elem.get_email().toLowerCase(),
                    Metadata: elem.get_metadata ? elem.get_metadata() : null,
                  };
                }),
            };
            break;
          case FIELDS_TYPES.MULTI_STRING:
            obj = {
              ...obj,
              [key]: item[key as keyof typeof fields],
            };
            break;
          case FIELDS_TYPES.MULTI_STRING_AND:
            obj = {
              ...obj,
              [key]: item[key as keyof typeof fields],
            };
            break;
          case FIELDS_TYPES.BOOLEAN:
            obj = { ...obj, [key]: !!item[key] };
            break;
          default:
            break;
        }
      });
      return obj;
    });
  }
);

export const modifiedItemsState = <K extends ListFieldsKeys>(
  objs: Record<number, ListFieldsRecordType[K]> | undefined,
  listName: K
) => {
  if (!objs) return [];

  let fields = listFields[listName];

  return Object.keys(objs).map((key) => {
    const item = objs[key as number];

    let obj: ListFieldsType[K] = {};
    Object.keys(item).forEach((key) => {
      switch (fields[key]) {
        case FIELDS_TYPES.STRING:
        case FIELDS_TYPES.NUMBER:
        case FIELDS_TYPES.ID:
        case FIELDS_TYPES.CHOICE:
        case FIELDS_TYPES.JSON:
          obj = { ...obj, [key]: item[key] };
          break;
        case FIELDS_TYPES.DATE:
          if (item[key]) obj = { ...obj, [key]: moment(item[key]) };
          else obj = { ...obj, [key]: null };
          break;
        case FIELDS_TYPES.LOOKUP:
          obj = {
            ...obj,
            [key]: item[key] && {
              Title: item[key].get_lookupValue(),
              ID: item[key].get_lookupId(),
              Metadata: item[key].get_metadata
                ? item[key].get_metadata()
                : null,
            },
          };
          break;
        case FIELDS_TYPES.MULTI_LOOKUP:
          obj = {
            ...obj,
            [key]:
              (item[key as keyof typeof fields] as any) &&
              item[key as keyof typeof fields].length > 0 &&
              item[key as keyof typeof fields].map((elem: any) => {
                return {
                  Title: elem.get_lookupValue(),
                  ID: elem.get_lookupId(),
                  Metadata: elem.get_metadata ? elem.get_metadata() : null,
                };
              }),
          };
          break;
        case FIELDS_TYPES.MEDIA:
          obj = {
            ...obj,
            [key]: item[key] && item[key].get_url(),
          };
          break;
        case FIELDS_TYPES.LINK:
          obj = {
            ...obj,
            [key]: item[key] && item[key].get_url(),
          };
          break;
        case FIELDS_TYPES.USER:
          obj = {
            ...obj,
            [key]: item[key] && {
              Name:
                (item[key].get_lookupValue && item[key].get_lookupValue()) ||
                item[key]["Name"] ||
                null,
              ID:
                (item[key].get_lookupId && item[key].get_lookupId()) ||
                item[key]["id"] ||
                null,
              Email:
                (item[key].get_email &&
                  item[key].get_email().toLowerCase().trim()) ||
                (item[key]["email"] &&
                  item[key]["email"].toLowerCase().trim()) ||
                null,
              Metadata: item[key].get_metadata
                ? item[key].get_metadata()
                : null,
            },
          };
          break;
        case FIELDS_TYPES.MULTI_USER:
          obj = {
            ...obj,
            [key]:
              (item[key as keyof typeof fields] as any) &&
              item[key as keyof typeof fields].length > 0 &&
              item[key as keyof typeof fields].map((elem: any) => {
                return {
                  Name: elem.get_lookupValue(),
                  ID: elem.get_lookupId(),
                  Email: elem.get_email() && elem.get_email().toLowerCase(),
                };
              }),
          };
          break;
        case FIELDS_TYPES.MULTI_STRING:
          obj = {
            ...obj,
            [key]: item[key as keyof typeof fields],
          };
          break;
        case FIELDS_TYPES.BOOLEAN:
          obj = { ...obj, [key]: !!item[key] };
          break;
        default:
          break;
      }
    });
    return obj;
  });
};

const makeSelectItemsByType = <K extends ListFieldsKeys>(itemType: K) =>
  createSelector(
    [
      (state: RootState) => state.spitems.elements.items[itemType],
      getObj,
      getFields,
    ],
    (items, objs, fields) => {
      if (!items || items.length === 0) return [];

      return items.map((key) => {
        const item = objs[key] as ListFieldsRecordType[K];

        let obj: ListFieldsType[K] | {} = {};

        Object.keys(item).forEach((keyItem) => {
          const key = keyItem as keyof typeof item;

          const fieldKey = (fields as (typeof listFields)[K])[key];

          switch (fieldKey) {
            case FIELDS_TYPES.STRING:
            case FIELDS_TYPES.NUMBER:
            case FIELDS_TYPES.ID:
            case FIELDS_TYPES.CHOICE:
              obj = { ...obj, [key]: item[key] };
              break;
            case FIELDS_TYPES.DATE:
              obj = { ...obj, [key]: moment(item[key]) };
              break;
            case FIELDS_TYPES.LOOKUP:
              if (item[key]) {
                obj = {
                  ...obj,
                  [key]: item[key] && {
                    Title: item[key].get_lookupValue(),
                    ID: item[key].get_lookupId(),
                  },
                };
              }
              break;
            case FIELDS_TYPES.MULTI_LOOKUP:
              obj = {
                ...obj,
                [key]:
                  item[key] &&
                  item[key].length > 0 &&
                  item[key].map((elem) => {
                    return {
                      Title: elem.get_lookupValue(),
                      ID: elem.get_lookupId(),
                    };
                  }),
              };
              break;
            case FIELDS_TYPES.MEDIA:
              obj = {
                ...obj,
                [key]: item[key] && item[key].url,
              };
              break;
            case FIELDS_TYPES.LINK:
              obj = {
                ...obj,
                [key]: item[key] && item[key].get_url(),
              };
              break;
            case FIELDS_TYPES.USER:
              obj = {
                ...obj,
                [key]: item[key] && {
                  Name: item[key].get_lookupValue(),
                  ID: item[key].get_lookupId(),
                  Email: item[key].get_email(),
                },
              };
              break;
            case FIELDS_TYPES.MULTI_USER:
              obj = {
                ...obj,
                [key]:
                  item[key] &&
                  item[key].length > 0 &&
                  item[key].map((elem) => {
                    return {
                      Name: elem.get_lookupValue(),
                      ID: elem.get_lookupId(),
                      Email: elem.get_email(),
                    };
                  }),
              };
              break;
            case FIELDS_TYPES.BOOLEAN:
              obj = { ...obj, [key]: !!item[key] };
              break;
            default:
              break;
          }
        });
        return obj;
      });
    }
  );

// Создание конкретных селекторов для каждого типа

// export const selectMyDocuments = makeSelectItemsByType(myDocumentsListName);
